import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Alert, Button, Card, Spinner } from "react-bootstrap";
import FormInput from "../../components/FormInput";
import { api } from "../../helpers/apiCore";
import { endpoints } from "../../helpers/Endpoints";
import logoMain from "../../assets/icons/logo_main.svg";
import successMark from "../../assets/icons/success_mark.svg";
import errorInfoIcon from "../../assets/icons/error_info.svg";
import { usePasswordResetContext } from "../../contexts/PasswordResetContex";
import '../../styles/auth.css';


const ResetPassword = () => {

	const { email, otp } = usePasswordResetContext();

	const [isSubmitting, setIsSubmitting] = useState(false);
	const [showAlert, setShowAlert] = useState(false);
	const [alertMessage, setAlertMessage] = useState<string | null>(null);
	const [alertVariant, setAlertVariant] = useState<"danger" | "success">("danger");
	const [error, setError] = useState<string | null>(null);
	const [formData, setFormData] = useState({
		otp: otp,
		email: email,
		password: "",
		confirmPassword: "",
	});

	const [showSuccessModal, setShowSuccessModal] = useState(false);

	const navigate = useNavigate();

	const handlePasswordReset = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();

		if (formData.password !== formData.confirmPassword) {
			setError("Passwords do not match");
			setShowAlert(true);
			return;
		};

		setIsSubmitting(true);
		setShowAlert(false);
		try {
			const response = await api.create(endpoints.resetPassword, {
				email: formData.email,
				resetPin: formData.otp,
				password: formData.password,
				passwordCheck: formData.confirmPassword
			});
			const responseData = response.data;
			setShowSuccessModal(true);
		} catch (error: any) {
			const message = error?.response?.data?.message || 'Unable to reset password, please try again';
			setError(message);
			setShowAlert(true);
			setAlertVariant("danger");
			setShowSuccessModal(false);
		} finally {
			setIsSubmitting(false);
		}
	};

	const navigateToLogin = () => {
		navigate('/')
	};

	return (
		<>
			<div className="body-bg-blue">
				<div className="auth-body">
					<div className="auth-img-white mb-3">
						<img src={logoMain} alt="logo" />
						<h2>Scholarswitch</h2>
					</div>

					{!showSuccessModal && (
						<Card>
							<Card.Body>
								<h3 className="mb-5">Reset Password</h3>
								<form onSubmit={handlePasswordReset}>
									<div className="mb-4 text-left">
										<FormInput
											label="New Password"
											type="password"
											name="password"
											value={formData.password}
											placeholder="**********"
											onChange={(e) => {
												setFormData({ ...formData, password: e.target.value });
												if (error) setError(null);
											}}
										/>
									</div>
									<div className="mb-3 text-left">
										<FormInput
											label="Re-enter New Password"
											name="confirmPassword"
											type="password"
											value={formData.confirmPassword}
											placeholder="**********"
											onChange={(e) => {
												setFormData({ ...formData, confirmPassword: e.target.value });
												if (error) setError(null);
											}}
										/>
									</div>

									{showAlert && (
										<Alert
											variant={alertVariant}
											className="alert-error"
										>
											{error && <img src={errorInfoIcon} alt="error" />}
											{alertVariant === "danger" ? error : alertMessage}
										</Alert>
									)}

									<Button type="submit" disabled={isSubmitting || !formData.password || !formData.confirmPassword}>
										{isSubmitting ? <Spinner animation="border" size="sm" /> : "Reset"}
									</Button>
								</form>
							</Card.Body>
						</Card>
					)}

					{/* reset success */}
					{showSuccessModal && (
						<Card>
							<Card.Body>
								<img src={successMark} alt="success" />
								<div className="success-modal-text">
									<h3>Reset Password</h3>
									<span>You password has been changed successfully. Log into your portal to continue</span>
								</div>
								<Button onClick={navigateToLogin}>Proceed to Login</Button>
							</Card.Body>
						</Card>
					)}
				</div>
			</div>
		</>
	)
};

export default ResetPassword;